import React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Button from "@components/buttons/Button/Button";
import ServiceSheetDocument, { ServiceSheetDocumentProps } from "./ServiceSheetDocument";

interface ServiceSheetPDFDownloadButtonProps extends ServiceSheetDocumentProps {
    overrideName?: string;
}

export const ServiceSheetPDFDownloadButton: React.FC<ServiceSheetPDFDownloadButtonProps> = ({
    serviceSheet,
    qrCodeBase64,
    overrideName,
    pageSize,
}) => {
    const defaultFileName = `${serviceSheet.firstName}_${serviceSheet.lastName}_ServiceSheet_${pageSize}.pdf`;
    const fileName = overrideName ? `${overrideName}_${pageSize}.pdf` : defaultFileName;

    return (
        <PDFDownloadLink
            document={(
                <ServiceSheetDocument
                    serviceSheet={serviceSheet}
                    qrCodeBase64={qrCodeBase64}
                    pageSize={pageSize}
                />
            )}
            fileName={fileName}
        >
            <Button variant="primary" size="medium" onClick={() => {}}>
                Download
            </Button>
        </PDFDownloadLink>
    );
};

export default ServiceSheetPDFDownloadButton;
